import { useAuthContext } from '../../auth';
import { routes } from '../../routes';
import { Link } from 'react-router-dom';

export const PlansContact = () => {
  const { user } = useAuthContext();

  // Obfuscated email to prevent scraping
  const getEmail = () => ['hello', 'mailcrunch.io'].join('@');

  return (
    <section className="relative py-24 px-6 overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-white to-rose-50" />

      {/* Decorative elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-600/5 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-rose-400/5 rounded-full blur-3xl" />

      <div className="relative max-w-4xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Get started today
          </h2>
          <p className="text-lg text-gray-500">
            Start with a free trial — limited projects, core editor features.
          </p>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {/* Free Trial Card */}
          <div className="relative p-8 rounded-2xl bg-white border-2 border-gray-100 shadow-sm">
            <div className="mb-6">
              <span className="inline-block px-3 py-1 rounded-full text-sm font-medium bg-gray-100 text-gray-700 mb-4">
                Free Trial
              </span>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">
                Start exploring
              </h3>
              <p className="text-gray-500">
                Perfect for evaluation. Get familiar with the workflow.
              </p>
            </div>

            <ul className="space-y-3 mb-8">
              {['Core editor features', 'Preview all variants', 'No time limits'].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-gray-600">
                  <svg className="w-5 h-5 text-blue-600 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  {item}
                </li>
              ))}
            </ul>

            {user ? (
              <Link
                to="/orgs"
                className="block w-full text-center py-4 px-6 rounded-xl bg-gray-100 text-gray-700 font-semibold hover:bg-gray-200 transition-colors"
              >
                Go to Dashboard
              </Link>
            ) : (
              <Link
                to={routes.login.getPath()}
                className="block w-full text-center py-4 px-6 rounded-xl bg-gray-900 text-white font-semibold hover:bg-gray-800 transition-colors"
              >
                Start Free Trial
              </Link>
            )}
          </div>

          {/* Pro Card */}
          <div className="relative p-8 rounded-2xl bg-gradient-to-br from-blue-600 to-blue-700 shadow-xl shadow-blue-600/20">
            <div className="mb-6">
              <span className="inline-block px-3 py-1 rounded-full text-sm font-medium bg-white/20 text-white mb-4">
                Pro
              </span>
              <h3 className="text-2xl font-bold text-white mb-2">
                For teams & agencies
              </h3>
              <p className="text-blue-100">
                Everything you need to streamline your email workflow.
              </p>
            </div>

            <ul className="space-y-3 mb-8">
              {['Send test emails', 'Veeva integration', 'Priority support'].map((item, i) => (
                <li key={i} className="flex items-center gap-3 text-blue-100">
                  <svg className="w-5 h-5 text-white flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  {item}
                </li>
              ))}
            </ul>

            <a
              href={`mailto:${getEmail()}?subject=Mailcrunch Pro Inquiry`}
              className="block w-full text-center py-4 px-6 rounded-xl bg-white text-blue-600 font-semibold hover:bg-blue-50 transition-colors"
            >
              Contact Us
            </a>
          </div>
        </div>

        {/* Bottom text */}
        <p className="text-center text-gray-500 mt-12">
          Questions? Reach out at{' '}
          <a
            href={`mailto:${getEmail()}`}
            className="text-blue-600 hover:underline font-medium"
          >
            {getEmail()}
          </a>
        </p>
      </div>
    </section>
  );
};
